// eslint-disable-next-line monorepo/no-internal-import
import type {AuthMedium} from '@aboutyou/user/src/user-state/userStore/types';

interface AddProduct {
  code: number;
  message?: string;
  productId?: number;
  statusText?: string;
  variantId: number;
  duration: number;
  sId: string;
}

interface Authentication {
  method: 'login' | 'register';
  medium: AuthMedium;
  code?: number;
  metadata?: any;
  reason?: string;
}

interface MergeEvent {
  code?: number;
  metadata?: any;
  reason?: string;
}

interface ResetPassword {
  type: 'request' | 'reset';
  metadata?: any;
}

interface Logout {
  type: 'userAction' | 'sessionValidator';
  metadata?: any;
}

interface PaypalExpress {
  statusCode?: number;
  message?: string;
}

interface SessionValidation {
  errorReason?: string;
  errorCode?: number;
  coSessionValid?: boolean;
  authMedium?: AuthMedium;
}

interface LoginCaptcha {
  errorCode?: string;
}

interface Captcha {
  errorCode?: string;
}

export const Add2BasketEvent = 'Add2Basket' as const;
export const RemoveFromWishlistEvent = 'RemoveFromWishlist' as const;
export const Add2WishlistEvent = 'Add2Wish' as const;
export const AuthenticationEvent = 'AuthenticationEvent' as const;
const BasketMergeEvent = 'BasketMergeEvent' as const;
const WishlistMergeEvent = 'WishlistMergeEvent' as const;
export const ResetPasswordEvent = 'ResetPasswordEvent' as const;
export const LogoutEvent = 'LogoutEvent' as const;
export const PaypalExpress = 'PaypalExpress' as const;
export const SessionValidation = 'SessionValidation' as const;
export const LoginCaptchaEvent = 'LoginCaptchaEvent' as const;
export const CaptchaEvent = 'CaptchaEvent' as const;

export interface CompareEvents {
  [Add2BasketEvent]: AddProduct;
  [Add2WishlistEvent]: AddProduct;
  [RemoveFromWishlistEvent]: AddProduct;
  [AuthenticationEvent]: Authentication;
  [BasketMergeEvent]: MergeEvent;
  [WishlistMergeEvent]: MergeEvent;
  [ResetPasswordEvent]: ResetPassword;
  [LogoutEvent]: Logout;
  [PaypalExpress]: PaypalExpress;
  [SessionValidation]: SessionValidation;
  [LoginCaptchaEvent]: LoginCaptcha;
  [CaptchaEvent]: Captcha;
}
